var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.items.length)?_c('div',{staticClass:"link-compilations-list"},_vm._l((_vm.items),function(item){return _c('LinkedCompItem',{key:item.id,attrs:{"item":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }